import { cellSpinnerHandler, getActiveModule } from '@/ts/utils';
import { ICellRendererParams } from 'ag-grid-community';
import { useState } from 'react'
import { FaTrashAlt } from 'react-icons/fa';
import { showToast } from '@/ts/modals';
import { REMOVE_ENTITY_CONFIG } from '@/ts/constants';
import { TRemoveEntityModules, UtilsModule } from '@/ts/common-types';
import { usePermissionCheck } from '@/hooks/AllCustomHooks';

const RemoveEntityCellRenderer = (params: ICellRendererParams) => {
    const { activeModule } = getActiveModule()
    const { removeFunc, recordId, recordKey } =
        REMOVE_ENTITY_CONFIG[activeModule as TRemoveEntityModules];
    const [identifier] = useState(params.data[recordId]);
    const { isModuleEditDisabled } = usePermissionCheck({ type: "cellRenderer" });

    const [loading, setLoading] = useState<boolean>(false);

    const onRemoveEntityClickHandler = async () => {
        let response;
        try {
            const removeMethod = ((await import("../../ts/utils")) as UtilsModule)[removeFunc];

            setLoading(true);
            response = await removeMethod([
                {
                    [recordKey]: params.data[recordId].toString(),
                    state: "archived",
                    attribute: ["state"],
                },
            ]);

            if (!response.status) {
                throw new Error(response.messages);
            }

            showToast("success", response.message);
            setLoading(false);
        } catch (err: any) {
            setLoading(false);
            showToast(
                "danger",
                `Failed to send record updation request: ${err.message}`
            );
        }
    }


    return (
        <>
            {
                params.node.rowPinned ? null : (
                    <button
                        className="btn btn-sm btn-danger"
                        id={`remove_negative_button_${identifier}`}
                        onClick={() => cellSpinnerHandler(setLoading, onRemoveEntityClickHandler)}
                        disabled={loading || isModuleEditDisabled}
                    >
                        {loading ? (
                            <i
                                className="spinner-border"
                                style={{ width: "1em", height: "1em" }}
                            />
                        ) : (
                            <FaTrashAlt style={{ transform: "translateY(-10%)" }} />
                        )}
                    </button>
                )
            }
        </>
    )
}

export default RemoveEntityCellRenderer;